import type { ManagerSelfServiceState } from "./types";

export const initialState: ManagerSelfServiceState = {
  requestsInProgress: 0,
  settings: {
    selfServiceEnabled: true,
    isLocked: false,
    changeSetState: null,
    addAndEditAbsences: false,
    cancelAbsences: false,
    notificationContactsAdmin: false,
  },
};

export default initialState;
